import react, { useEffect, useState } from "react";
import config from "../../config/config";
import Header from "../directives/header";
import { Container, Row, Col, Button, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../directives/footer";
import "../css/unitronixexplained.css"
import { getEmpoweringFeaturesData } from "../../apis/apiAction";

const Empowerfeature = () => {
  const [BannerData, setBannerData] = useState([]);


  useEffect(() => {
    getBannerData();
  }, []);

  const getBannerData = async () => {
    try {
      let res = await getEmpoweringFeaturesData()
      if (res.data) {
        setBannerData(res.data);
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };


  return (
    <>
      <Header />
      <main style={{ paddingTop: "80px" }}>
        <section className="unitronixexplained position-relative">
          <Container className="">
            <Row className="align-items-center">
              <Col lg={6} className="mb-4">
                <div className="heading mb-4">
                  <h1 className="text-white mb-0">
                    {/* Empowering Features – */}
                    {BannerData.firstHeading}
                    <div className="text-primary">
                      {/* Have Sky is the limit under Empowering Features */}
                      {BannerData.secondHeading}
                    </div>
                  </h1>
                </div>
                <p className="">
                  {BannerData.description}
                  {/* Unitronix is at the forefront of technological innovation, transforming the internet and redefining financial systems through */}
                </p>
                <div>
                  <ul>
                    <li className="mb-4"><b className="text-white fw-semibold">{BannerData.feature01Heading}
                    </b>
                      {BannerData.feature01Description}
                      {/* Automating complex financial transactions with precision and transparency. Our smart contracts streamline processes like debt issuance, interest distribution, and trigger-based actions, drastically reducing reliance on intermediaries. */}
                    </li>
                    <li className="mb-4"><b className="text-white fw-semibold">
                      {BannerData.feature02Heading}
                      {/* Blockchain Integration : */}
                    </b>
                      {/* Creating secure and immutable records for asset lifecycle management and convertible debt instruments. Blockchain’s decentralized nature ensures data integrity, accessibility, and compliance with global standards. */}
                      {BannerData.feature02Description}
                    </li>
                    {BannerData.feature03Heading && BannerData.feature03Description && (
                      <li className="mb-4">
                        <b className="text-white fw-semibold">{BannerData.feature03Heading}</b>
                        {BannerData.feature03Description}
                      </li>
                    )}
                    {BannerData.feature04Heading && BannerData.feature04Description && (
                      <li className="mb-4">
                        <b className="text-white fw-semibold">{BannerData.feature04Heading}</b>
                        {BannerData.feature04Description}
                      </li>
                    )}
                  </ul>
                </div>
              </Col>
              <Col lg={6} className="mb-4">
                <div className="text-center">
                  <div >
                    <img src="assets/images/feature.svg" width={`100%`} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">

              <Col lg={6} className="mb-4">
                <div className="text-center">
                  <div >
                    <img src="assets/images/innovation.svg" width={`100%`} />
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mb-4">
                <div className="heading mb-4">
                  <h1 className="text-white mb-0">
                    Advanced Innovations
                  </h1>
                </div>
                <p className="">
                  {BannerData.advancedInnovationsDescription}
                  {/* Our technology is designed to resolve inefficiencies in traditional financial systems by */}
                </p>
                <div>
                  <ul>
                    <li className="mb-4"><b className="text-white fw-semibold">
                      {/* Automating Lifecycle Management : */}
                      {BannerData.innovations01Heading}
                    </b>
                      {BannerData.innovations01Description}
                      {/*  From issuance to settlement, smart contracts autonomously execute predefined actions, ensuring accuracy and timeliness. */}
                    </li>
                    <li className="mb-4"><b className="text-white fw-semibold">
                      {/* Enhanced Liquidity : */}
                      {BannerData.innovations02Heading}

                    </b>
                      {BannerData.innovations02Description}

                      {/* Tokenized instruments can be traded globally without intermediaries, fostering a more inclusive and accessible financial ecosystem. */}
                    </li>
                    {BannerData.innovations03Heading && BannerData.innovations03Description && (
                      <li className="mb-4">
                        <b className="text-white fw-semibold">{BannerData.innovations03Heading}</b>
                        {BannerData.innovations03Description}
                      </li>
                    )}
                    {BannerData.innovations04Heading && BannerData.innovations04Description && (
                      <li className="mb-4">
                        <b className="text-white fw-semibold">{BannerData.innovations04Heading}</b>
                        {BannerData.innovations04Description}
                      </li>
                    )}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>


        <section className="keybenefits py-0">
          <Container>
            <Row>
              <Col lg={12} className="mb-5 pb-5">
                <div className="text-center">
                  <div className="">
                    <h1 className="text-white">Key Benefits</h1>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="">
                <Row>
                  <Col lg={3} md={6} className="mb-5">
                    <Card className="text-center border-0 p-3">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/costefficiency.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">Cost Efficiency</h4>
                            <p>{BannerData.costEfficiency}</p>
                            {/* <p>Eliminates manual oversight and intermediary fees, reducing operational costs significantly.</p> */}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={3} md={6} className="mb-5">
                    <Card className="text-center border-0 p-3">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/oversight.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">Oversight</h4>
                            <p>
                              {BannerData.oversight}
                              {/* Constant monitoring for peace of mind */}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={3} md={6} className="mb-5">
                    <Card className="text-center border-0 p-3">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/global.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">Global Accessibility</h4>
                            <p>
                              {BannerData.globalAccessibility}
                              {/* Facilitates cross-border investments with built-in compliance automation. */}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={3} md={6} className="mb-5">
                    <Card className="text-center border-0 p-3">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/transparencyTrust.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">Transparency and Trust</h4>
                            <p>
                              {BannerData.transparencyAndTrust}
                              {/* Blockchain’s immutable ledger ensures stakeholders have a clear, tamper-proof view of all transactions. */}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

              </Col>

            </Row>
          </Container>
        </section>
        <section className="testionial position-relative mb-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-5">
                <div className="testimonialBox">
                  <Card className="rounded-4 p-4 border border-primary">
                    <div className="quote quoteBlue">
                      <img src="assets/images/icon/upqoute.svg" />
                    </div>
                    <Card.Body className="">
                      <div className="w-100 text-center">
                        <div className="mb-0">
                          <p className="fs-5 lh-lg">
                            {BannerData.quote}
                            {/* By integrating blockchain technology and innovative systems, Unitronix transforms traditional financial processes into efficient, transparent, and accessible solutions for all stakeholders. */}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                    <div className="quote quoteGreen" style={{ bottom: "-25px" }}>
                      <img src="assets/images/icon/downquote.svg" />
                    </div>
                  </Card>
                </div>
                <hr className="testimonialLine border-primary" />

              </Col>

            </Row>
          </Container>
        </section>

      </main>

      <Footer />
    </>
  );
};
export default Empowerfeature;
